import BottomNavigation from "components/BottomNavigation"
import { SaveButton } from "components/Buttons"
import { FORM_NAMES } from "constants/index"
import React, { useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import { FormSection, reduxForm } from "redux-form"
import CommuniationTab from "./communiationTab"
import DetailsTab from "./detailsTab"
import InformationTab from "./informationTab"
import PricingTab from "./pricingTab"
import RegistrationTab from "./registrationTab"
import WebpageTab from "./webpageTab"

const SpecificEvents = ({ handleBack }) => {
  const TABS = {
    INFORMATION: 1,
    DETAILS: 2,
    PRICING: 3,
    REGISTRATION: 4,
    COMMUNICATION: 5,
    WEBPAGE: 6,
  }

  const [activeTab, setActiveTab] = useState(TABS.INFORMATION)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  return (
    <Card>
      <CardBody className="ms-5">
        <Row className="d-flex justify-content-between">
          <Col xs="auto"></Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Done"
              color="light"
              onClick={handleBack}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col xs="auto">
            <Nav pills className="flex-column">
              <NavLink
                className={markIfIsActive(TABS.INFORMATION)}
                onClick={() => setActiveTab(TABS.INFORMATION)}
              >
                {<span style={{ fontSize: "16px" }}>Information</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.DETAILS)}
                onClick={() => setActiveTab(TABS.DETAILS)}
              >
                {<span style={{ fontSize: "16px" }}>Details</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.PRICING)}
                onClick={() => setActiveTab(TABS.PRICING)}
              >
                {<span style={{ fontSize: "16px" }}>Pricing</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.REGISTRATION)}
                onClick={() => setActiveTab(TABS.REGISTRATION)}
              >
                {<span style={{ fontSize: "16px" }}>Registration</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.COMMUNICATION)}
                onClick={() => setActiveTab(TABS.COMMUNICATION)}
              >
                {<span style={{ fontSize: "16px" }}>Communication</span>}
              </NavLink>
              <NavLink
                className={markIfIsActive(TABS.WEBPAGE)}
                onClick={() => setActiveTab(TABS.WEBPAGE)}
              >
                {<span style={{ fontSize: "16px" }}>Web Page</span>}
              </NavLink>
            </Nav>
          </Col>
          <Col>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.INFORMATION}>
                <FormSection name="information">
                  <InformationTab />
                </FormSection>
                <BottomNavigation
                  handleNext={() => setActiveTab(TABS.DETAILS)}
                />
              </TabPane>
              <TabPane tabId={TABS.DETAILS}>
                <FormSection name="details">
                  <DetailsTab />
                </FormSection>
                <BottomNavigation
                  handleNext={() => setActiveTab(TABS.PRICING)}
                  handleBack={() => setActiveTab(TABS.INFORMATION)}
                />
              </TabPane>
              <TabPane tabId={TABS.PRICING}>
                <FormSection name="pricing">
                  <PricingTab />
                </FormSection>
                <BottomNavigation
                  handleNext={() => setActiveTab(TABS.REGISTRATION)}
                  handleBack={() => setActiveTab(TABS.DETAILS)}
                />
              </TabPane>
              <TabPane tabId={TABS.REGISTRATION}>
                <FormSection name="registration">
                  <RegistrationTab />
                </FormSection>
                <BottomNavigation
                  handleNext={() => setActiveTab(TABS.COMMUNICATION)}
                  handleBack={() => setActiveTab(TABS.PRICING)}
                />
              </TabPane>
              <TabPane tabId={TABS.COMMUNICATION}>
                <FormSection name="communication">
                  <CommuniationTab />
                </FormSection>
                <BottomNavigation
                  handleNext={() => setActiveTab(TABS.WEBPAGE)}
                  handleBack={() => setActiveTab(TABS.REGISTRATION)}
                />
              </TabPane>
              <TabPane tabId={TABS.WEBPAGE}>
                <FormSection name="webpage">
                  <WebpageTab />
                </FormSection>
                <BottomNavigation
                  handleBack={() => setActiveTab(TABS.COMMUNICATION)}
                />
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: FORM_NAMES.CALENDAR_EVENT,
    initialValues: {
      registration: {
        registration: [
          {
            name: "General Admission",
            price: 5.0,
            maxGuest: 20,
            maxRSVP: 2,
          },
          {
            name: "Backstage Passes",
            price: 20.0,
            maxGuest: 5,
            maxRSVP: 2,
          },
        ],
      },
      communication: {
        reminderNotifications: [
          { type: 1, time_period: 10 },
          { type: 2, time_period: 15 },
        ],
      },
    },
  })(SpecificEvents)
)
